import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';
import { APP_STATE_TOKEN } from '../store/app.store.state';
import { ROUTES_URL } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router
  ) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    // return this.appStore.state$.pipe(map(x => x.globalConfig)).pipe(

    //   skipWhile(config => !config.configuration || config.error), map(config => {
    //     if (config.error) {
    //       return false;
    //     }

    //     if (!this.appStore.state.session.isLoggedIn) {
    //       this.appStore.uiAction.setBlockUi(true);
    //       window.location.href = this.appStore.globalConfigAction.buildUrlLoginPunku(state.url);
    //       return false;
    //     }
    //     return true;
    //   })
    // );

    const { session } = this.store.selectSnapshot(APP_STATE_TOKEN);

    if (!session.isLoggedIn) {
      this.router.navigate([ROUTES_URL.LOGIN]);
      return false;
    }
    return true;
  }


}
